import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { texts } from './paths';

const TextTransition = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let startTimestamp = null;
    let requestId = null;

    const animate = timestamp => {
      if (!startTimestamp) startTimestamp = timestamp;

      const elapsed = timestamp - startTimestamp;

      if (elapsed > 5000) {
        // 5000ms or 5 seconds
        setCurrentIndex(prevIndex => (prevIndex + 1) % texts.length);
        startTimestamp = timestamp;
      }

      requestId = requestAnimationFrame(animate);
    };

    requestId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(requestId);
  }, []);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="text-center tw-text-2xl tw-font-bold"
        key={currentIndex}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{ duration: 0.5 }}
      >
        {texts[currentIndex]}
      </motion.div>
    </AnimatePresence>
  );
};

export default TextTransition;
